import router from '@/router/router'

/**
 * this function resolves route config to actual route
 * @param route
 * @returns {{location: Location, route: Route, href: string, normalizedTo: Location, resolved: Route}}
 */
export default route => router.resolve(route)
